import React from 'react';
import { useController, UseControllerProps } from 'react-hook-form';
import { Autocomplete, Checkbox, FormControl, MenuItem, TextField } from '@mui/material';

interface IProps extends UseControllerProps {
    label: string;
    placeholderText?: string;
    size?: "small" | "medium";
    disabled?: boolean;
    options: string[];
    setOptions: React.Dispatch<React.SetStateAction<string[]>>;
}
const AppInsertMultiSelection = (props: IProps) => {
    const { fieldState: { error }, field } = useController({ ...props, defaultValue: [] });
    const selectedOptions = props.options.filter(option => field.value.includes(option));

    const handleAddOptions = (options: string[]) => {
        props.setOptions(options);
        field.onChange(options);
    };
    return (
        <FormControl fullWidth error={!!error}>
            <Autocomplete
                {...props}
                {...field}
                freeSolo
                multiple
                disableCloseOnSelect
                options={props.options}
                value={selectedOptions}
                onChange={(event, value) => {
                    handleAddOptions(value);
                }}
                renderOption={(props, option) => {
                    return (
                        <MenuItem key={option} value={option} {...props}>
                            <Checkbox checked={field.value.includes(option)} />
                            {option}
                        </MenuItem>
                    )
                }}
                renderInput={
                    (params) => <TextField
                        {...params}
                        fullWidth
                        label={props.label}
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <React.Fragment>
                                    {params.InputProps.endAdornment}
                                </React.Fragment>
                            ),
                        }}
                        variant="outlined"
                        placeholder={props.placeholderText}
                        size={props.size}
                        error={!!error}
                    />
                }
            />
            {error && Array.isArray(error) ? (
                <div>
                    {error.map((err, index) => (
                        <div style={{ color: "red", fontSize: "0.75em" }} key={index}>{err.message}</div>
                    ))}
                </div>
            ) : (
                error && <div>{error.message}</div>
            )}
        </FormControl>)
}

export default AppInsertMultiSelection;